import { styled } from '@mui/material/styles';
import { Box as BoxMui, Typography as TypographyMui } from '@mui/material';
interface IconStyles {
  [key: string]: { color: string };
}
export const StyledBox = styled(BoxMui)(({ theme }) => ({
  display: 'flex',
  alignItems: 'space-around',
  marginRight: theme.spacing(5)
}));

export const Box = styled(BoxMui)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: theme.spacing(1)
}));

export const iconStyles: IconStyles = {
  photo: { color: '#75bdd7' },
  residential: { color: '#2196f3' },
  lot: { color: '#90caf9' }
};

export const Typography = styled(TypographyMui)(() => ({
  fontWeight: 'bold',
  color: 'white',
  paddingLeft: '5px'
}));
